module.exports = __webpack_public_path__ + "img/white-bulb-icon.dab61b0e.png";